import { filter_page_size } from './apiUtils';

// The list loaders return [everything accumulated so far, total, error] for
// one page at a time. This walks every page and returns the full list. If a
// later page fails it keeps the pages already loaded; if the first page fails
// it throws, so there is nothing to show and nothing is cached.
// `partial` says a later page failed, so the cache can load the list again on
// the next visit instead of keeping it as if it were whole. It travels with the
// list (not as a mark on the array) because the cache copies refetched data.
export type PagedList<T> = { items: T[]; partial: boolean };

export const fetchAllPages = async <T>(
  loadPage: (
    offset: number,
    accumulated: T[],
  ) => Promise<[T[], number, Error | null]>,
): Promise<PagedList<T>> => {
  let accumulated: T[] = [];
  let offset = 0;
  while (true) {
    const [items, total, error] = await loadPage(offset, accumulated);
    if (error) {
      if (offset === 0) throw error;
      return { items: accumulated, partial: true };
    }
    accumulated = items;
    if (offset + filter_page_size >= total) break;
    offset += filter_page_size;
  }
  return { items: accumulated, partial: false };
};
